require('figma-plugin-bypass');
var Crypto = require('ezcrypto').Crypto;
//require('./x-frame-bypass');
//https://www.npmjs.com/package/figma-plugin-bypass

//jQuery( document ).ready( function( $ ) {
	if($('body').hasClass('single-post')){
		console.log("it's a single post");
		if($('body').hasClass('noFrame')){
			$('img.attachment-penci-full-thumb').attr("style",'min-height:'+$('img.attachment-penci-full-thumb').attr('height')/2+'px;');
		}
			var height = $('div.standard-content-special').outerHeight();
			console.log(height);
			$('img.attachment-penci-full-thumb').height(height+60);
		}
//});




if(ps_ajax_object["x-frame-bypass"]){

    customElements.whenDefined('x-frame-bypass').then(() => {
        
        console.log("%c%s", "color: #5555ff; font-size:30px;","x-frame-bypass is defined");
        
        customElements.define('l-frame-bypass', class extends customElements.get('x-frame-bypass') {
            
            get proxy() {
                return this.getAttribute('proxy');
            }

            set proxy(newValue) {
                this.setAttribute('proxy', newValue);
            }
            
            constructor (props) {
                super(props)
                this.options = {}
                console.log("%c%s", "color: #ff5555; font-size:30px;","l-frame-bypass constructor");
                console.log(props);
                console.log(this.proxy);
                if(ps_ajax_object["x-frame-bypass-proxy"] !== ""){
                        console.log("%c%s", "color: #ff5555; font-size:30px;","has an encrypted proxy");
                        var decryptedkey = Crypto.AES.decrypt(ps_ajax_object["x-frame-bypass-proxy-key"],'cappsl');
                        var decryptedproxy = Crypto.AES.decrypt(ps_ajax_object["x-frame-bypass-proxy"],decryptedkey);
                        this.options.proxies = [decryptedproxy]
                }else if(this.proxy !== null){
                    console.log("%c%s", "color: #ff5555; font-size:30px;","has a proxy");
                    this.options.proxies = [this.proxy]
                }
            }
            
            attributeChangedCallback () {
                this.load(this.src,this.options)
            }
            
            Onmouseover(){
                console.log("test");
            }
            
        }, {extends: 'iframe'});
        
    });


    customElements.define('l-frame', class extends HTMLIFrameElement {
        static get observedAttributes() {
            return ['src']
        }
        constructor (props) {
            super(props)
            this.options = {
                mode: 'no-cors'
            }
            console.log("%c%s", "color: #ff5555; font-size:30px;","l-frame constructor");
        }
        
        connectedCallback () {
            console.log("connectedCallback");
        }
        
        attributeChangedCallback() {
            console.log("attributeChangedCallback");
            //this.load(this.src)
        }
        
    }, {extends: 'iframe'})

}
